import { useEffect, useRef, useState } from "react";
import reactLogo from "./assets/react.svg";
import viteLogo from "/vite.svg";
import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./components/HomePage";
import { useAppContext } from "./AppContext";
import TermsAndCondition from "./components/TermsAndCondition";
import EmailCSV from "./components/EmailCSV";
import DownloadPage from "./components/DownLoadPage";
import MarketingKit from "./components/MarketingKit";
import CommercialCleaningLanding from "./components/CommercialCleaningLanding";
import CommercialCleaningPromote from "./components/CommercialCleaningPromote";
import HomePageSpanish from "./components/HomePageSpanish";
import ConseguirClientesLimpieza from "./components/ConseguirClientesLimpieza";
import PromocionarNegocioLimpieza from "./components/PromocionarNegocioLimpieza";
import AdminPayments from "./pages/AdminPayments";
import { ES_HOME_PATH, EN_HOME_PATH, ES_THANKYOU_PATH, ES_CLIENTS_PATH, ES_PROMOTE_PATH } from "./routes";

function NotFoundRedirect() {
  const savedLang = typeof localStorage !== "undefined" ? localStorage.getItem("site_lang") : null;
  return <Navigate to={savedLang === "es" ? ES_HOME_PATH : EN_HOME_PATH} replace />;
}

function App() {
  const { setClientSecret, buyNow, loadingHeader, setLoadingHeader, selectedPrice, preferredPaymentMethod } = useAppContext();

  const apiBase = "https://app.commercialcleaningleadsforyou.com"
  

const creatingIntentRef = useRef(false);
const lastIntentKeyRef = useRef("");

useEffect(() => {
  if (buyNow !== "payment") return;
  if (!selectedPrice) return;

  const intentKey = `${buyNow}-${selectedPrice}`;

  // Prevent duplicate calls for same state
  if (lastIntentKeyRef.current === intentKey) return;

  // Prevent concurrent calls
  if (creatingIntentRef.current) return;

  creatingIntentRef.current = true;
  lastIntentKeyRef.current = intentKey;

  const controller = new AbortController();

  (async () => {
    try {
      setLoadingHeader(true);

      const response = await fetch(`${apiBase}/api/create-payment-intent`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          amount: selectedPrice,
          currency: "usd",
          preferredPaymentMethod: preferredPaymentMethod || null,
        }),
        signal: controller.signal,
      });

      if (!response.ok) {
        const errText = await response.text();
        throw new Error(`HTTP ${response.status}: ${errText}`);
      }

      const data = await response.json();

      if (!data.clientSecret) {
        throw new Error("No client secret received");
      }

      console.log("PaymentIntent payment_method_types:", data.paymentMethodTypes || []);
      setClientSecret(data.clientSecret);
    } catch (err) {
      if (err.name !== "AbortError") {
        console.error("Error creating payment intent:", err);
        // allow retry if failed
        lastIntentKeyRef.current = "";
      }
    } finally {
      creatingIntentRef.current = false;
      setLoadingHeader(false);
    }
  })();

  return () => {
    controller.abort();
  };
}, [buyNow, selectedPrice, apiBase, setClientSecret]);
  
  
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/thank-you" element={<DownloadPage />} />
      <Route path="/downloadcsv/*" element={<EmailCSV />} />
      {/* <Route path="/marketingkit" element={<MarketingKit />} /> */}
      <Route
        path="/how to get clients for your commercial cleaning business"
        element={<CommercialCleaningLanding />}
      />
      <Route
        path="/how to promote your commercial cleaning business"
        element={<CommercialCleaningPromote />}
      />
      <Route path={ES_HOME_PATH} element={<HomePageSpanish />} />
      <Route path={ES_THANKYOU_PATH} element={<DownloadPage />} />
      <Route path={ES_CLIENTS_PATH} element={<ConseguirClientesLimpieza />} />
      <Route path={ES_PROMOTE_PATH} element={<PromocionarNegocioLimpieza />} />
      <Route path="*" element={<NotFoundRedirect />} />
    </Routes>
  );
}

export default App;
